import React, {useState, useEffect} from 'react';
import {useParams, useHistory} from 'react-router-dom';
import MyModal from "../forum/DetailModal/Modal";
import {getSpecificPost} from "../../firebase/getData";
var cloneDeep = require('lodash.clonedeep');

export default function UserModalWrapper(props) {
  const { postID } = useParams();
  let history = useHistory();
  const [modalData, setModalData] = useState(null);
  const { authorData, setAuthorData } = props;

  useEffect(() => { //First render
    if (postID) getSpecificPost({postID}).then((post) => setModalData(post));
  }, []);

  const handleVote = (newUpvoters, sign) => {
    const tempRows = cloneDeep(authorData.posts);
    tempRows.forEach(row => {
      if (row.postID === postID) {
        if (sign === -1) row.upvotes = row.upvotes - 1;
        if (sign === 1) row.upvotes = row.upvotes + 1;
        row.upvoters = newUpvoters;
      } 
    })
    setAuthorData({...authorData, posts: tempRows});
  }

  let returnItem;
  if (modalData && Object.keys(modalData).length !== 0) {
    returnItem = <MyModal modalData={modalData} setModalData={setModalData} handleVote={handleVote} userURL={`/users/${props.authorID}`}/>
  } else if (modalData && Object.keys(modalData).length === 0) history.push(`/users/${props.authorID}`); //Set up warning for this.
  else returnItem = null;

  return (
    <div>
      {returnItem}
    </div>
  )
}